export const getHeadingAnchor = (level: number, text: string) => {
  return `H${level}_${text.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 25)}`;
};
